/* ALERTBOX
 * --------
 *  When captcha connexion clicked with successfull mdp
 *      - display a custom alertbox with 2 buttons:
 *          --> oui: ouvrir le salon privé
 *          --> non: fermer l'alertbox
 *      - also display a translucent background called "voilegris"
 *
 */

import { AlertboxOptions } from '@js/types'
import { makeUnselectable, Fade } from '@js/utils'
import css from '@css/sass/styles.module.scss'


class Voilegris {
  voile: HTMLElement | null = null

  setup() {
    this.voile = document.createElement('div')
    this.voile.id = css.voilegris
    document.body.appendChild(this.voile)
    this.voile.style.display = 'none'
  }

  display(delay = 0) {
    /** delay: ms */
    if (!this.voile) return
    Fade.fadeInWithDelay(this.voile!, 600, delay)     // setTimeout(() => Fade.fadeIn(this.voile!, 600), delay)
  }

  hide() {
    if (!this.voile) return
    this.voile.style.display = 'none'
  }

}

export class Alertbox {
  private vg: Voilegris
  private ab: HTMLDivElement | null = null
  private btnOui: HTMLButtonElement | null = null
  private btnNon: HTMLButtonElement | null = null 
  private fadein: number = 1000

  constructor(options: AlertboxOptions) {
    options.object = this
    this.fadein = options.fadein

    this.vg = new Voilegris() // fond gris
  }

  setup () {
    // main box
    this.ab = document.createElement('div')
    document.body.appendChild(this.ab)
    this.ab.id = css.alertbox
    this.ab.className = css.box
    makeUnselectable(this.ab)

    // title
    const boxTitleContainer = document.createElement('div')
    this.ab.appendChild(boxTitleContainer)
    boxTitleContainer.className = css.title
    const boxTitle = document.createElement('h2')
    boxTitleContainer.appendChild(boxTitle)
    boxTitle.innerHTML = 'Vous vous apprêtez à pénétrer dans la chambre privée.'

    // body
    const boxBodyContainer = document.createElement('div')
    this.ab.appendChild(boxBodyContainer)
    boxBodyContainer.className = 'body'

    this.btnOui = document.createElement('button')
    boxBodyContainer.appendChild(this.btnOui)
    this.btnOui.className = css.btn
    this.btnOui.innerHTML = 'poursuivre'

    this.btnNon = document.createElement('button')
    boxBodyContainer.appendChild(this.btnNon)
    this.btnNon.className = css.btn
    this.btnNon.innerHTML = 'annuler'

    // create voilegris
    this.vg.setup()

    console.debug('[Alertbox] set up')
  }

  display(options: {
    delay?: number,
    oui_clicked?: () => void,
    non_clicked?: () => void
  } = {}) {
    const delay = (options.delay ?? 0) * 1000
    const oui = options.oui_clicked
    const non = options.non_clicked
    Fade.fadeInWithDelay(this.ab!, this.fadein, delay)
    this.vg.display(delay)
    this.alertboxListener(oui, non)
  }
  
  clear() {
    // carefull, can't be used again if not re-setuped
    if (this.ab !== null && this.ab.parentNode) {
      this.ab.parentNode.removeChild(this.ab)
    }
  }
  
  private alertboxListener(
    oui?: () => void,
    non?: () => void
  ) {
    if (!this.btnOui || !this.btnNon) return

    this.btnOui.addEventListener('click', () => {
      console.debug("alertbox: 'oui' clicked")
      oui?.()
    })

    this.btnNon.addEventListener('click', () => {
      console.debug("alertbox: 'non' clicked")
      non?.()
      if (this.ab) this.ab.style.display = 'none'
      if (this.vg.voile) this.vg.voile.style.display = 'none'
    })

    this.btnOui.addEventListener('mouseenter', () => {
      console.debug('alertbox: mouseenter oui')
      // optional: display GIF
    })
  }

}

